<template>
  <div id="shas-app" :class="isRTL ? 'rtl' : ''">
    <div>
      <shas-header />
    </div>
    <div class>
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <div>
      <shas-footer />
    </div>
    <mm-modal></mm-modal>
    <authorization-modal></authorization-modal>
    <VerifyNotice></VerifyNotice>

    <i class="fa fa-2x text-primary fa-arrow-circle-up backtop" id="backtop" @click="toTop()"></i>
  </div>
</template>
<script>
import mmModalComponent from './partials/ActionButtons/mmModal.vue';
import HeaderComponent from './partials/Header.vue';
import FooterComponent from './partials/Footer.vue';
import AuthorizationModalComponent from './authorization/Modal.vue';
import { mapState } from 'vuex';
import VerifyNotice from './authorization/VerifyNotice.vue';

export default {
  metaInfo: function () {
    return {
      titleTemplate: function (title) {
        return title ? this.$_t('KW:site.metaWithName', { name: title }) : this.$_t('KW:site.metaWithoutName');
      },
      htmlAttrs: {
        lang: 'en',
        amp: undefined, // "amp" has no value
      },
    };
  },
  data: function () {
    return {
      scrollTop: false,
    };
  },
  created: function () {
    window.onscroll = function () {
      scrollFunction();
    };
    function scrollFunction() {
      if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        document.getElementById('backtop').style.display = 'block';
      } else {
        document.getElementById('backtop').style.display = 'none';
      }
    }
  },
  components: {
    mmModal: mmModalComponent,
    ShasHeader: HeaderComponent,
    ShasFooter: FooterComponent,
    AuthorizationModal: AuthorizationModalComponent,
    VerifyNotice,
  },
  methods: {
    toTop: function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and
      window.scrollTo(0, 0);
    },
  },
  computed: {
    ...mapState({
      showLoader: function (state) {
        return state.api.loader;
      },
    }),
  },
};
</script>
<style lang="scss" scoped>
.loader-container {
  background: #5aadd36b;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  // z-index: 10000;
}
#loader {
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  border-top: 8px solid $secondary;
  width: 40px;
  height: 40px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>